import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface CompanyOption {
  value: string;
  label: string;
}

export function useCompanyOptions() {
  const [options, setOptions] = useState<CompanyOption[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCompanies() {
      try {
        const { data, error: fetchError } = await supabase
          .from('nrm_companies')
          .select('id, name')
          .order('name');

        if (fetchError) throw fetchError;
        
        setOptions(
          (data || []).map(company => ({
            value: company.id,
            label: company.name
          }))
        );
      } catch (err) {
        setError('Failed to load companies');
        console.error('Fetch error:', err);
      } finally {
        setLoading(false);
      }
    }

    fetchCompanies();
  }, []);

  return { options, loading, error };
}